import {
  DatePicker,
  IComboBox,
  IComboBoxOption,
  Panel,
  PanelType,
} from "@fluentui/react";
import React, { useCallback } from "react";
import { PanelHeader } from "../../../../components/Panel/PanelHeader";
import { PanelFooter } from "../../../../components/Panel/PanelFooter";
import { ComboBoxIDS } from "../../../../components/generic/ComboBoxIDS";
import { onFormatDate } from "../../../../utils/helpers/dateHelpers";
import {
  IDateFilter,
  IFilterDispositivosAsignados,
  IFilterReporteDispositivoAsignado,
} from "../../../../Interfaces/DispositivoAsignado/IDispositivoAsignado";
import { DescargarArchivo } from "../../../../components/archivo/DescargarArchivo";
import { useReporteAsignacionDispositivo } from "../../../../hooks/Reportes/useReporteAsignacionDispositivo";
import { useComboGuardias } from "../../../../hooks/combosHooks/useComboGuardias";
import { useComboAreas } from "../../../../hooks/combosHooks/useComboAreas";
interface IPanelFilterDispositivoAsignados {
  isOpen: boolean;
  onDismiss: () => void;
  onSelectDate: (date: Date | null | undefined, text: string) => void;
  limpiarFiltro: () => void;
  filterFechas: any;
  filter: IFilterDispositivosAsignados;
  buscar: () => void;
  filterReporte: IFilterReporteDispositivoAsignado;
  onChangeComboGuardia: (
    event: React.FormEvent<IComboBox>,
    option?: IComboBoxOption,
    text?: string
  ) => void;
}

export const PanelFilterDispositivoAsignados = (
  props: IPanelFilterDispositivoAsignados
) => {
  const { handlerReporteDispositivosAsignados, isSend } =
    useReporteAsignacionDispositivo(props.onDismiss);

  const onRenderHeader = useCallback(
    () => (
      <>
        <PanelHeader
          textHeader={`Filtro de dispositivo asignado`}
          subTextHeader={`Búsqueda Avanzada`}
        />
      </>
    ),
    []
  );
  const onRenderFooter = useCallback(
    () => (
      <>
        <PanelFooter
          texto="Buscar"
          texto2={"Limpiar"}
          onClick={props.buscar}
          disableButton={false}
          onDismiss={props.limpiarFiltro}
        />
      </>
    ),
    [props.onDismiss, props.limpiarFiltro]
  );
  const { comboBoxRefGuardias, dataComboGuardia, onClickOpenGuardias } =
    useComboGuardias();
  const { _onKeyUpSearchArea, comboBoxAreaRef, dataComboArea, onClickOpen } =
    useComboAreas();
  return (
    <div>
      <Panel
        type={PanelType.smallFixedFar}
        onRenderHeader={onRenderHeader}
        onRenderFooter={onRenderFooter}
        isFooterAtBottom
        isBlocking={false}
        isOpen={props.isOpen}
        onDismiss={props.onDismiss}
      >
        <>
          <div className="ms-Grid" dir="ltr">
            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                <br />
                <br />
                <DatePicker
                  label="Fecha Entrega Desde:"
                  placeholder="dd/mm/yyyy"
                  value={props.filterFechas.filterFechaInicio}
                  ariaLabel="Seleccione una fecha"
                  onSelectDate={(data?: any) => {
                    props.onSelectDate(data, "inicio");
                  }}
                  formatDate={onFormatDate}
                  underlined
                />
              </div>
              <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                <br />
                <br />
                <DatePicker
                  label="Fecha Entrega Hasta:"
                  placeholder="dd/mm/yyyy"
                  value={props.filterFechas.filterFechaFin}
                  ariaLabel="Seleccione una fecha"
                  onSelectDate={(data?: any) => {
                    props.onSelectDate(data, "fin");
                  }}
                  formatDate={onFormatDate}
                  minDate={props.filterFechas.filterFechaInicio}
                  underlined
                />
              </div>
              <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                <br />
                <br />
                <ComboBoxIDS
                  title="Guardia:"
                  componentRef={comboBoxRefGuardias}
                  selectedKey={props.filter?.guardia}
                  onClick={onClickOpenGuardias}
                  useComboBoxAsMenuWidth
                  onChange={(e, o) =>
                    props.onChangeComboGuardia(e, o, "guardia")
                  }
                  KeyUp={undefined}
                  options={dataComboGuardia}
                />
              </div>
              <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                <br />
                <br />
                <ComboBoxIDS
                  title="Area:"
                  componentRef={comboBoxAreaRef}
                  selectedKey={props.filter?.areaId}
                  onClick={onClickOpen}
                  useComboBoxAsMenuWidth
                  onChange={(e, o) => props.onChangeComboGuardia(e, o, "area")}
                  KeyUp={_onKeyUpSearchArea}
                  options={dataComboArea}
                />
              </div>
            </div>
          </div>
          <DescargarArchivo
            onClick={() => {
              handlerReporteDispositivosAsignados(props.filterReporte);
            }}
            isSend={isSend}
          />
        </>
      </Panel>
    </div>
  );
};
